module.exports = __webpack_public_path__ + "img/eva-manage-active.81502b11.svg";